// import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import styles from "./StudentModal.module.css";
import { relationOptions } from "../../../constant";
import Dropdown from "../../Dropdown/dropdown";
// import { Button } from "react-bootstrap";
// import SignInInput from "../../../common/SigninInput/signinInput";

const StudentModal = ({
  studentRelationLoading,
  setStudentRelation,
  selectedStudentName,
  remitterName,
  isOpen,
  onRequestClose,
  onSubmit,
  studentRelationError,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Student Details Modal"
      className={styles.modalBase}
      overlayClassName={styles.overlayBase}
      shouldCloseOnOverlayClick={true}
      closeTimeoutMS={300}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            {`Please select the relation between ${selectedStudentName} and ${remitterName}`}
          </h2>
        </div>

        <div className={styles.modalBody} style={{ minHeight: "200px" }}>
          <Dropdown
            isFromStudentModal={true}
            options={relationOptions}
            label="Select Relation"
            heading="Relation with Student"
            onChange={(selectedOption) => {
              setStudentRelation(selectedOption);
            }}
            errorMessage={studentRelationError}
          />
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={onRequestClose}
            className={styles.cancelButton}
            disabled={studentRelationLoading}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className={styles.submitButton}
            disabled={studentRelationLoading}
          >
            {studentRelationLoading ? (
              <div className={styles.loadingContainer}>
                <div className={styles.spinner}></div>
                Loading...
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default StudentModal;
